// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"9306b8c6","769":"fb063fd8"}[chunkId] + ".chunk.js";
};